import React from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import VerticalNavLink from '../verticalNavLink';

function MAListReferenceComponents({ onActive, handleDrawerToggle }) {
    return (
        <List disablePadding>
            <VerticalNavLink
                onActive={onActive}
                to={'/manager-agents/jobs/job-templates/job-templates-overview'}
                onClick={handleDrawerToggle}
                secondary={'Overview'}
            />

            <VerticalNavLink
                onActive={onActive}
                to={'/manager-agents/jobs/job-templates/configuring-workflows'}
                onClick={handleDrawerToggle}
                secondary={'Configuring Workflows'}
            />

            <VerticalNavLink
                onActive={onActive}
                to={'/manager-agents/jobs/job-templates/workflow-components'}
                onClick={handleDrawerToggle}
                secondary={'Workflow Components'}
            />

            <VerticalNavLink
                onActive={onActive}
                to={'/manager-agents/jobs/job-templates/component-sequence-diagrams'}
                onClick={handleDrawerToggle}
                secondary={'Sequence Diagrams'}
            />
        </List>
    );
}

MAListReferenceComponents.propTypes = {
    onActive: PropTypes.func,
    handleDrawerToggle: PropTypes.func,
};

export default MAListReferenceComponents;
